// Константы для приложения

export const TRADE_TYPES = {
  BUY: 'BUY' as const,
  SELL: 'SELL' as const,
};

export const FILTER_FIELDS = [
  'month_order',
  'month_finish_rate',
  'max_low_single_trans_amount',
  'min_high_single_trans_amount',
  'average_size',
] as const;

export const FILTER_LABELS = {
  month_order: 'Month order',
  month_finish_rate: 'Month finish rate',
  max_low_single_trans_amount: 'Max Min amount',
  min_high_single_trans_amount: 'Min Max amount',
  average_size: 'Average size',
};

export const BREAKPOINTS = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
};

export const MODAL_WIDTHS = {
  mobile: '95%',
  tablet: '80%',
  desktop: '60%',
};

export const MESSAGES = {
  SUCCESS: {
    FIAT_CREATED: 'Валюта успешно создана',
    SOUP_CREATED: 'Суп успешно создан',
    SOUP_UPDATED: 'Суп успешно обновлен',
    EXCHANGE_UPDATED: 'Биржа успешно обновлена',
    FILTER_UPDATED: 'Фильтр успешно обновлен',
    FIAT_DELETED: 'Валюта успешно удалена',
    SOUP_DELETED: 'Суп успешно удален',
    EXCHANGE_DELETED: 'Биржа успешно удалена',
  },
  ERROR: {
    GENERIC: 'Произошла ошибка',
    NETWORK: 'Ошибка сети',
    VALIDATION: 'Проверьте правильность заполнения полей',
  },
  CONFIRM: {
    DELETE_FIAT: 'Вы уверены, что хотите удалить эту валюту? Все связанные данные будут потеряны.',
    DELETE_SOUP: 'Вы уверены, что хотите удалить этот суп? Все связанные биржи будут удалены.',
    DELETE_EXCHANGE: 'Вы уверены, что хотите удалить эту биржу? Все связанные фильтры будут удалены.',
  },
};
